import { Theme } from "@mui/material";
import { SystemStyleObject } from "@mui/system";

export const footerHeight = "80px";

export const classes: Record<string, SystemStyleObject<Theme>> = {
  root: {
    // position: "fixed",
    // bottom: "0",
    width: "100%",
    zIndex: 1100,
  },

  toolbar: {
    backgroundColor: "#0C0C0C",
    display: "flex",
    justifyContent: "space-between",
  },

  small: {
    height: "56px",
  },

  info: {
    color: "#A7A7A7",
    fontSize: "12px",
  },

  socials: {
    display: "flex",
    alignItems: "center",
    color: "primary.dark",
  },
};
